"use client";

import { Popover, PopoverContent } from "@workspace/frontend-ui";
import { type FC, useMemo, useState } from "react";
import type { ProviderFragment, SelectedProvider } from "../../../types";
import sortProvidersByName from "./helpers/sortProvidersByName";
import ProviderDropdownList from "./ProviderDropdownList";
import ProviderDropdownTrigger from "./ProviderDropdownTrigger";

type Props = {
  allProviders?: ProviderFragment[];
  enabledProviders?: SelectedProvider[];
  toggleProvider: (provider: SelectedProvider) => void;
};

const ProviderDropdown: FC<Props> = ({
  allProviders,
  enabledProviders,
  toggleProvider,
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const sortedProviders = useMemo(
    () => sortProvidersByName(allProviders || []),
    [allProviders],
  );

  const selectedProviders = enabledProviders || [];

  const handleClearProviders = () => {
    selectedProviders.forEach((provider) => {
      toggleProvider(provider);
    });
  };

  if (!sortedProviders.length) return null;

  return (
    <Popover onOpenChange={setIsVisible} modal>
      <ProviderDropdownTrigger
        isVisible={isVisible}
        enabledProviders={selectedProviders}
        onRemoveProvider={toggleProvider}
        onClearProviders={handleClearProviders}
      />
      <PopoverContent
        align="center"
        className="w-(--radix-popover-trigger-width) overflow-y-auto max-h-[300px] bg-background"
      >
        <ProviderDropdownList
          providers={sortedProviders}
          enabledProviders={selectedProviders}
          onToggleProvider={toggleProvider}
        />
      </PopoverContent>
    </Popover>
  );
};

export default ProviderDropdown;
